import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { EmptyStateAddButton } from './EmptyStateAddButton';
import { EmptyStateSecondaryButton } from './EmptyStateSecondaryButton';
import { PanelEmptyState } from './PanelEmptyState';

interface DocumentAnalyzeEmptyStateProps {
  illustration: React.ReactNode;
  titleKey: string;
  descriptionKey: string;
  addLabelKey: string;
  analyzeLabelKey: string;
  canEdit: boolean;
  onAdd: () => void;
  onAnalyze: () => void;
  isAnalyzing: boolean;
  analyzeDisabled: boolean;
  analyzeTooltip?: string;
}

export const DocumentAnalyzeEmptyState: React.FC<DocumentAnalyzeEmptyStateProps> = ({
  illustration,
  titleKey,
  descriptionKey,
  addLabelKey,
  analyzeLabelKey,
  canEdit,
  onAdd,
  onAnalyze,
  isAnalyzing,
  analyzeDisabled,
  analyzeTooltip,
}) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={illustration}
      title={t(titleKey)}
      description={t(descriptionKey)}
      actions={
        canEdit ? (
          <>
            <EmptyStateSecondaryButton
              onClick={onAnalyze}
              disabled={analyzeDisabled || isAnalyzing}
              tooltip={analyzeTooltip}
            >
              {isAnalyzing ? t('analyzing') : t(analyzeLabelKey)}
            </EmptyStateSecondaryButton>
            <EmptyStateAddButton onClick={onAdd}>{t(addLabelKey)}</EmptyStateAddButton>
          </>
        ) : undefined
      }
    />
  );
};
